import { Reveal } from '@/components/motion';
import { FLEET, IMAGES } from '@/data/site';
import { CheckCircle, ArrowRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { public_api } from '@/lib/api';

const STATIC_FLEET = FLEET.map(f => ({ ...f, id: f.name, image_url: IMAGES[f.image] || IMAGES.fleet_van }));

export default function Fleet() {
  const [vehicles, setVehicles] = useState(STATIC_FLEET);
  useEffect(() => {
    public_api.fleet().then(v => { if (v?.length) setVehicles(v); }).catch(() => {});
  }, []);
  return (
    <>
      <section className="pt-16 md:pt-24 pb-14" data-testid="fleet-hero">
        <div className="container-x">
          <div className="max-w-4xl">
            <Reveal>
              <div className="overline mb-6">Our fleet</div>
              <h1 className="h-display text-balance">A modern fleet, engineered around every passenger.</h1>
              <p className="body-lg mt-8 max-w-2xl text-pretty">
                From wheelchair-accessible vans and side-lift vehicles to community sedans and group mini-buses —
                our vehicles are safety-inspected quarterly, cleaned between every trip and specced for real people.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="pb-24" data-testid="fleet-grid">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 gap-5">
          {vehicles.map((f, i) => (
            <Reveal key={f.id || f.name} delay={i * 0.05}>
              <div className="rounded-3xl overflow-hidden border border-neutral-200 bg-neutral-50 group">
                <div className="aspect-[16/10] overflow-hidden bg-neutral-100">
                  <img src={f.image_url || IMAGES.fleet_van} alt={f.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-7">
                  <div className="flex items-center justify-between mb-4">
                    <span className="badge-brand">{f.type}</span>
                    <span className="text-xs uppercase tracking-widest text-ink-muted font-semibold">Capacity · {f.capacity}</span>
                  </div>
                  <h3 className="font-display font-bold text-2xl text-ink">{f.name}</h3>
                  <ul className="mt-4 space-y-2">
                    {f.features.map(x => (
                      <li key={x} className="flex items-center gap-2 text-sm text-ink-soft">
                        <CheckCircle size={16} weight="fill" className="text-brand" /> {x}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-24">
        <div className="container-x">
          <Reveal>
            <div className="rounded-3xl bg-neutral-50 border border-neutral-200 p-10 md:p-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-8">
                <h2 className="h-section text-balance">Not sure which vehicle is right for the trip?</h2>
                <p className="body-md mt-3">Tell us who's travelling and what they need — we'll match the vehicle and driver at no extra cost.</p>
              </div>
              <div className="lg:col-span-4 flex flex-col gap-3">
                <Link to="/quote" className="btn-primary">Get a tailored quote <ArrowRight size={16} weight="bold" /></Link>
                <Link to="/contact" className="btn-secondary">Speak to a coordinator</Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
